import React from 'react';
import styles from './LogoSign.module.css';

const LogoSign = () => {
  return (
    <div className={styles.logoSign}>
      <img src="/technexus-sign.png" alt="Technexus Sign" />
    </div>
  );
};

export default LogoSign;